import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { StatusBar, Style } from "@capacitor/status-bar";
import { QueryClientProvider } from 'react-query';
import { queryClient } from './queries/client';


const container = document.getElementById('root');
const root = createRoot(container!);
StatusBar.setBackgroundColor({
  color: "#ffffff"
});
StatusBar.setOverlaysWebView({ overlay: false });
StatusBar.setStyle({ style: Style.Light });
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
